import Vue from 'vue'
import { Button, Menu, MenuItem, Popover, Image } from 'element-ui'

Vue.use(Button)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Popover)
Vue.use(Image)